// --- React & Redux
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
// --- External UI Libraries
import { Drawer } from 'antd';
// --- Components
import { AssociationsForm } from './associations-form';
// --- Actions & Hooks
import { useRightsActions } from 'datastage/store/rights/useRights';
// --- Styles
import './styles.scss';

/**
 * Rights Associate Drawer
 *
 * Features:
 * - Renders a drawer UI for managing rights associations
 * - Scrolls to top when opened
 * - Handles closing the drawer and clearing state
 *
 * @returns {Element}
 * @constructor
 */
export const RightsAssociateDrawer = () => {
    const { isAssociateOpen, details } = useSelector((state) => state.rights);
    const { updateRights, clearAssociationsDrawer } = useRightsActions();

    // Scroll drawer body to top when opened
    useEffect(() => {
        if (isAssociateOpen) {
            setTimeout(() => {
                const el = document.querySelector('.ant-drawer-body');
                if (el) el.scrollTop = 0;
            }, 0);
        }
    }, [isAssociateOpen]);

    // Close the drawer and clear form state
    const handleClose = () => {
        updateRights({
            isAssociateOpen: false,
        });
        clearAssociationsDrawer();
    };


    return (
        <Drawer
            className="associations-drawer"
            title="Associations"
            width={750}
            placement="right"
            open={isAssociateOpen}
            onClose={handleClose}
            bodyStyle={{ paddingBottom: 80 }}
        >
            <AssociationsForm details={details}  />
        </Drawer>
    );
};
